import React from 'react'
import styled from 'styled-components'
import { Table } from '../Table/Table'
import { colors } from '../_styles/colors'
import { getTypographyIntent } from './Typography.styles'

const StyledBodyCell = styled(Table.BodyCell)``

const StyledTextCell = styled(Table.TextCell)`
  ${getTypographyIntent('body')}
  color: ${colors.blue50};
`

function BodyCell() {
  return (
    <StyledBodyCell data-core="styled-body-cell">
      <Table.InputCell placeholder="Placeholder" />
    </StyledBodyCell>
  )
}

function TextRow() {
  return (
    <Table.BodyRow>
      <Table.BodyCell>
        <Table.Checkbox />
      </Table.BodyCell>

      <Table.BodyCell>
        <StyledTextCell>Some text here</StyledTextCell>
      </Table.BodyCell>

      <Table.BodyCell>
        <StyledTextCell>Some text here</StyledTextCell>
      </Table.BodyCell>

      <Table.BodyCell>
        <StyledTextCell>Some text here</StyledTextCell>
      </Table.BodyCell>

      <Table.BodyCell>
        <StyledTextCell>Some text here</StyledTextCell>
      </Table.BodyCell>

      <Table.BodyCell>
        <StyledTextCell>Some text here</StyledTextCell>
      </Table.BodyCell>
    </Table.BodyRow>
  )
}

function RowGenerator() {
  return (
    <Table.BodyRow>
      <Table.BodyCell>
        <Table.Checkbox />
      </Table.BodyCell>

      <BodyCell />

      <BodyCell />

      <BodyCell />

      <BodyCell />

      <BodyCell />
    </Table.BodyRow>
  )
}

let rows: any[] = []
for (let i = 0; i < 1000; i++) {
  rows.push(RowGenerator())
}

export function GiantTable() {
  return (
    <Table.Container>
      <Table>
        <Table.Header>
          <Table.HeaderRow>
            <Table.HeaderCell variant="snugfit">
              <Table.Checkbox />
            </Table.HeaderCell>

            <Table.HeaderCell sortable variant="asc">
              Link
            </Table.HeaderCell>

            <Table.HeaderCell sortable>Column Key</Table.HeaderCell>

            <Table.HeaderCell>Column Key</Table.HeaderCell>

            <Table.HeaderCell>Percentages</Table.HeaderCell>

            <Table.HeaderCell>Currency</Table.HeaderCell>
          </Table.HeaderRow>
        </Table.Header>

        <Table.Body>
          <TextRow />
          {rows}
        </Table.Body>
      </Table>
    </Table.Container>
  )
}
